import axios from "axios";

const airtableBaseUrl = process.env.REACT_APP_AIRTABLE_BASE_URL; 
const airtableToken = process.env.REACT_APP_AIRTABLE_ACCESS_TOKEN; 


console.log("Airtable Base URL:", airtableBaseUrl);
console.log("Airtable Access Token:", airtableToken ? "Loaded successfully" : "Not loaded");

const airtable = axios.create({
  baseURL: airtableBaseUrl,
  headers: {
    Authorization: `Bearer ${airtableToken}`,
  },
});


export const fetchTableData = async () => {
  try {
    console.log("Fetching data from Airtable...");
    let allRecords = [];
    let offset;

    do {
      const response = await airtable.get("/Sales%20GCI%20%26%20Tier%20Report", {
        params: { offset },
      });
      console.log("Airtable Response Data:", response.data);

      if (response.data.records && response.data.records.length > 0) {
        allRecords = [...allRecords, ...response.data.records];
        offset = response.data.offset; 
      } else {
        offset = null; 
      }
    } while (offset);

    console.log("Total Records fetched:", allRecords.length);
    return allRecords;
  } catch (error) {
    console.error("Error fetching data from Airtable:", error.response?.data || error.message);
    throw error;
  }
};

export const fetchTableDataFromHRSync = async () => {
  try {
    console.log("Fetching data from Airtable...");
    let allRecords = [];
    let offset;

    do {
      const response = await airtable.get("/HR%20Sync", {
        params: { offset },
      });
      console.log("Airtable Response Data:", response.data);

      if (response.data.records && response.data.records.length > 0) {
        allRecords = [...allRecords, ...response.data.records];
        offset = response.data.offset; 
      } else {
        offset = null; 
      }
    } while (offset);

    console.log("Total Records fetched:", allRecords.length);
    return allRecords;
  } catch (error) {
    console.error("Error fetching data from Airtable:", error.response?.data || error.message);
    throw error;
  }
};
// Enhanced helper function to process email values
// Enhanced Rex Sync functions with case-insensitive matching
export const fetchAllRexSyncRecords = async () => {
  try {
    console.log("📋 Fetching all Rex Sync records");

    let allRecords = [];
    let offset;

    do {
      const response = await airtable.get(`/Rex%20Sync`, {
        params: { offset },
      });

      if (response.data.records && response.data.records.length > 0) {
        allRecords = [...allRecords, ...response.data.records];
        offset = response.data.offset;
      } else {
        offset = null;
      }
    } while (offset);

    console.log(`📋 Retrieved ${allRecords.length} records from Rex Sync`);
    return allRecords;
  } catch (error) {
    console.error("❌ Error fetching Rex Sync data:", error.response?.data || error.message);
    throw error;
  }
};

export const fetchUserStatsByEmail = async (email) => {
  try {
    console.log(`🔍 REX SYNC: Searching for email: ${email}`);

    // Normalize the email for case-insensitive matching
    const normalizedEmail = email.trim().toLowerCase();
    
    // Get all records and search locally for case-insensitive matching
    const allRecords = await fetchAllRexSyncRecords();
    
    if (!allRecords || allRecords.length === 0) {
      console.error("❌ REX SYNC: No records available");
      return null;
    }

    // Search through all records for case-insensitive email match
    for (const record of allRecords) {
      const fields = record.fields;
      
      if (fields.Email && typeof fields.Email === 'string') {
        const recordEmail = fields.Email.trim().toLowerCase();
        
        if (recordEmail === normalizedEmail) {
          console.log(`✅ REX SYNC: Case-insensitive match found: ${fields.Email}`);
          return fields;
        }
      }
    }

    console.warn(`❌ REX SYNC: No matching record found for email: ${email}`);
    
    // Debug: Show available emails
    console.log("🔍 REX SYNC: Available emails:");
    const availableEmails = allRecords
      .map(record => record.fields.Email)
      .filter(email => email)
      .map(email => email.trim().toLowerCase());
    
    console.log(availableEmails.sort());
    
    return null;
  } catch (error) {
    console.error("❌ REX SYNC: Error:", error.response?.data || error.message);
    throw error;
  }
};

export const fetchCoreMarketByEmail = async (email) => {
  try {
    console.log(`Fetching Core Market data for email: ${email}`);
    const formula = `{Image Email (from HR Sync)}="${email}"`; 
    const encodedFormula = encodeURIComponent(formula);
    const response = await airtable.get(
      `/Sales%20Core%20Market?filterByFormula=${encodedFormula}`
    );

    console.log("Core Market response:", response.data);

    if (response.data.records && response.data.records.length > 0) {
      console.log("Core Market data fetched successfully:", response.data.records[0].fields);
      return response.data.records[0].fields;
    }

    console.warn(`No matching record found for email: ${email}`);
    return null;
  } catch (error) {
    console.error("Error fetching Core Market data from Airtable:", error.response?.data || error.message);
    throw error;
  }
};

export const fetchCountByEmail = async (email) => {
  try {
    console.log(`Fetching Sales Live Listings data for email: ${email}`);
    const formula = `{Image Email (from HR Link)}="${email}"`;
    const encodedFormula = encodeURIComponent(formula);
    const response = await airtable.get(
      `/Sales%20Live%20Listings?filterByFormula=${encodedFormula}`
    );

    console.log("Sales Live Listings response:", response.data);

    if (response.data.records && response.data.records.length > 0) {
    
      const count = response.data.records.length;
      console.log(`Found ${count} records for email: ${email}`);
      return { count, records: response.data.records };
    }

    console.warn(`No matching records found in Sales Live Listings for email: ${email}`);
    return { count: 0, records: [] };
  } catch (error) {
    console.error("Error fetching Sales Live Listings data from Airtable:", error.response?.data || error.message);
    throw error;
  }
};


// Fetch lead count by email from "Sales Lead Conversion"
export const fetchLeadCountByEmail = async (email) => {
  try {
    console.log(`Fetching lead conversion rate for: ${email}`);

    // Get Total Leads from "Dash Table Total Leads" view
    const totalFormula = `{Image Email (from HR Sync)}="${email}"`;
    const totalRes = await airtable.get(
      `/Sales%20Lead%20Conversion?view=Dash%20Table%20Total%20Leads&filterByFormula=${encodeURIComponent(totalFormula)}`
    );
    const totalLeads = totalRes.data.records.length || 0;

    // Get Converted Leads from "Dash Table Converted Leads" view
    const convertedFormula = `{Image Email (from HR Sync)}="${email}"`;
    const convertedRes = await airtable.get(
      `/Sales%20Lead%20Conversion?view=Dash%20Table%20Converted%20Leads&filterByFormula=${encodeURIComponent(convertedFormula)}`
    );
    const convertedLeads = convertedRes.data.records.length || 0;

    // Calculate Conversion Rate
    const conversionRate = totalLeads > 0 
      ? ((convertedLeads / totalLeads) * 100).toFixed(2) 
      : 0;

    return {
      email,
      totalLeads,
      convertedLeads,
      conversionRate: `${conversionRate}%`
    };

  } catch (error) {
    console.error("Error fetching lead conversion data:", error.response?.data || error.message);
    throw error;
  }
};


// Fetch lead count by email from "PM Sales Conversions"
export const fetchPMSalesConversionsCountByEmail = async (email) => {
  try {
    console.log(`Fetching Sales Conversion data for email: ${email}`);
    const formula = `{Image Email (from HR Link)}="${email}"`;
    const encodedFormula = encodeURIComponent(formula);
    const response = await airtable.get(
      `/PM%20Sales%20Conversions?filterByFormula=${encodedFormula}`
    );

    console.log("Sales Conversion response:", response.data);

    if (response.data.records && response.data.records.length > 0) {
      const count = response.data.records.length;
      console.log(`Found ${count} records for email: ${email}`);
      return { count, records: response.data.records };
    }

    console.warn(`No matching records found in PM Sales Conversions for email: ${email}`);
    return { count: 0, records: [] };
  } catch (error) {
    console.error("Error fetching Sales Conversion data from Airtable:", error.response?.data || error.message);
    throw error;
  }
};



export const fetchPUMCountByEmail = async (email) => {
  try {
    console.log(`Fetching PUM data for email: ${email}`);
    const formula = `{Image Email (from HR Link)}="${email}"`;
    const encodedFormula = encodeURIComponent(formula);
    const response = await airtable.get(
      `/Sales%20%26%20PM%20PUM's%20Referred?filterByFormula=${encodedFormula}`
    );

    console.log("PUM data response:", response.data);

    if (response.data.records && response.data.records.length > 0) {
      const count = response.data.records.length;
      console.log(`Found ${count} records in PUM data for email: ${email}`);
      return { count, records: response.data.records };
    }

    console.warn(`No matching records found in PUM data for email: ${email}`);
    return { count: 0, records: [] };
  } catch (error) {
    console.error("Error fetching PUM data from Airtable:", error.response?.data || error.message);
    throw error;
  }
};

export const fetchPUMCoreCountByEmail = async (email) => {
  try {
    console.log(`Fetching PUM Core data for email: ${email}`);
    const formula = `{Image Email (from HR Sync)}="${email}"`;
    const encodedFormula = encodeURIComponent(formula);
    const response = await airtable.get(
      `/Sales%20PUM's%20in%20Core?filterByFormula=${encodedFormula}`
    );

    console.log("PUM Core data response:", response.data);

    if (response.data.records && response.data.records.length > 0) {
      const count = response.data.records.length;
      console.log(`Found ${count} records in PUM Core data for email: ${email}`);
      return { count, records: response.data.records };
    }

    console.warn(`No matching records found in PUM Core data for email: ${email}`);
    return { count: 0, records: [] };
  } catch (error) {
    console.error("Error fetching PUM Core data from Airtable:", error.response?.data || error.message);
    throw error;
  }
};

export const fetchCountFromBDMSecuredByEmail = async (email) => {
  try {
    console.log(`Fetching BDM Secured data for email: ${email}`);
    const formula = `{Image Email (from HR Link)}="${email}"`;
    const encodedFormula = encodeURIComponent(formula);
    const endpoint = `/BDM%20Form%206%20Secured%20%26%20Avg%20MGMT%25?filterByFormula=${encodedFormula}`;
    
    console.log(`API Endpoint: ${endpoint}`);
    
    let records = [];
    let offset;

    do {
      const response = await airtable.get(`${endpoint}&offset=${offset || ""}`);
      records = records.concat(response.data.records);
      offset = response.data.offset; 
    } while (offset);

    console.log("Fetched records:", records);

    const totalCount = records.reduce((sum, record) => {
      const count = record.fields.Count || 0; 
      return sum + count;
    }, 0);

    const totalMgmtFee = records.reduce((sum, record) => {
      const mgmtFee = parseFloat(record.fields["MGMT Fee %"]) || 0; 
      return sum + mgmtFee;
    }, 0);

    const avgMgmtFee = records.length > 0 ? (totalMgmtFee / records.length).toFixed(2) : 0; 

    console.log(`Total count for email ${email}: ${totalCount}`);
    console.log(`Average MGMT Fee % for email ${email}: ${avgMgmtFee}`);

    return { totalCount, avgMgmtFee, records };
  } catch (error) {
    console.error("Error fetching BDM Secured data:", error.response?.data || error.message);
    throw error;
  }
};

// Fetch NB count by email from "BDM Secured NB"
export const fetchNBCountFromBDMByEmail = async (email) => {
  try {
    console.log(`Fetching NB count from BDM Secured NB data for email: ${email}`);

    const formula = `{Image Email (from HR Link)}="${email}"`;
    const encodedFormula = encodeURIComponent(formula);

    const endpoint = `/BDM%20Secured%20NB?filterByFormula=${encodedFormula}`;
    
    console.log(`API Endpoint: ${endpoint}`);
    
    let records = [];
    let offset;

    do {
      const response = await airtable.get(`${endpoint}&offset=${offset || ""}`);
      records = records.concat(response.data.records);
      offset = response.data.offset; 
    } while (offset);

    console.log("Fetched records:", records);

    const totalCount = records.reduce((sum, record) => {
      const count = record.fields.Count || 0; 
      return sum + count;
    }, 0);

    console.log(`Total NB count for email ${email}: ${totalCount}`);

    return { totalCount, records };
  } catch (error) {
    console.error("Error fetching NB count from BDM Secured NB data:", error.response?.data || error.message);
    throw error;
  }
};

/// Fetch Leads to Sales count by email from "PM Sales Leads" table
export const fetchLeadsToSalesCountByEmail = async (email) => {
  try {
    console.log(`Fetching Leads to Sales data for email: ${email}`);
    const formula = `{Image Email (from HR Link)}="${email}"`;
    const encodedFormula = encodeURIComponent(formula);
    const endpoint = `/PM%20Sales%20Leads?filterByFormula=${encodedFormula}`;

    console.log(`API Endpoint: ${endpoint}`);

    let records = [];
    let offset;

    do {
      const response = await airtable.get(`${endpoint}&offset=${offset || ""}`);
      records = records.concat(response.data.records);
      offset = response.data.offset; 
    } while (offset);

    console.log("Fetched records:", records);

    const totalCount = records.reduce((sum, record) => {
      const count = record.fields.Count || 0; 
      return sum + count;
    }, 0);

    console.log(`Total count for email ${email}: ${totalCount}`);
    return { totalCount, records };
  } catch (error) {
    console.error("Error fetching Leads to Sales data:", error.response?.data || error.message);
    throw error;
  }
};

export const fetchAvoidableLossCountByEmail = async (email) => {
  try {
    console.log(`Fetching Avoidable Loss data for email: ${email}`);
    const formula = `{Image Email (from HR Link)}="${email}"`;
    const encodedFormula = encodeURIComponent(formula);
    const endpoint = `/PM%20Avoidable%20Losses?filterByFormula=${encodedFormula}`;

    console.log(`API Endpoint: ${endpoint}`);
    let records = [];
    let offset;

    do {
      const response = await airtable.get(`${endpoint}&offset=${offset || ""}`);
      records = records.concat(response.data.records);
      offset = response.data.offset; 
    } while (offset);

    console.log("Fetched records:", records);
    const totalCount = records.reduce((sum, record) => {
      const count = record.fields.Count || 0; 
      return sum + count;
    }, 0);

    console.log(`Total Avoidable Loss count for email ${email}: ${totalCount}`);
    return { totalCount, records };
  } catch (error) {
    console.error("Error fetching Avoidable Loss data:", error.response?.data || error.message);
    throw error;
  }
};

export const fetchUserDepartment = async () => {
  try {
    console.log("Fetching data from the HR Sync table for Sales and BDM departments...");

    const response = await airtable.get(
      `/HR%20Sync?filterByFormula=OR({Department}="Sales", {Department}="BDM")`
    );

    console.log("Filtered HR Sync table response:", response.data);

    if (response.data.records && response.data.records.length > 0) {
      const formattedData = response.data.records.map((record) => ({
        Employee: record.fields.Employee || "Unknown",
        Department: record.fields.Department || "Unknown",
        ImageEmail: record.fields["Image Email"] || "N/A", 
        Image: record.fields.Image || null,
      }));

      console.log("Formatted Data From the HR Sync:", formattedData);
      return formattedData; 
    }

    console.warn("No records found for Sales and BDM departments in the HR Sync table.");
    return []; 
  } catch (error) {
    console.error(
      "Error fetching data for Sales and BDM departments from the HR Sync table:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const deleteEmployeeById = async (id) => {
  try {
    console.log(`Deleting employee with ID: ${id} from the HR Sync table...`);

    const response = await airtable.delete(`/HR%20Sync/${id}`);

    if (response.status === 200) {
      console.log(`Successfully deleted employee with ID: ${id}`);
      return true; 
    } else {
      console.warn(`Unexpected response while deleting employee with ID: ${id}`, response.data);
      return false;
    }
  } catch (error) {
    console.error(`Error deleting employee with ID: ${id} from the HR Sync table:`, error.response?.data || error.message);
    throw error; 
  }
};


export const fetchPUMsUnderByEmail = async (email) => {
  try {
    console.log(`Fetching PUMs Under data for email: ${email}`);

    const formula = `{Image Email}="${email}"`;
    const encodedFormula = encodeURIComponent(formula);
    const endpoint = `/HR%20Sync?filterByFormula=${encodedFormula}`;

    console.log(`API Endpoint: ${endpoint}`);
    let records = [];
    let offset;

    do {
      const response = await airtable.get(`${endpoint}&offset=${offset || ""}`);
      records = records.concat(response.data.records);
      offset = response.data.offset;
    } while (offset);

    console.log("Fetched records:", records);

    const pumUnder = records.length > 0 ? records[0].fields["PUMs Under"] : null;

    console.log(`PUMs Under for email ${email}: ${pumUnder}`);
    return pumUnder;
  } catch (error) {
    console.error("Error fetching PUMs Under data:", error.response?.data || error.message);
    throw error;
  }
};

export const fetchImageRankingFromBDM = async (email) => {
  try {
    console.log(`Fetching Image Ranking data for email: ${email}`);

    const formula = `{Image Email (from link)}="${email}"`;
    const encodedFormula = encodeURIComponent(formula);
    const endpoint = `/BDM%20Image%20Ranking?filterByFormula=${encodedFormula}`;

    console.log(`API Endpoint: ${endpoint}`);
    let records = [];
    let offset;

    do {
      const response = await airtable.get(`${endpoint}&offset=${offset || ""}`);
      records = records.concat(response.data.records);
      offset = response.data.offset;
    } while (offset);

    console.log("Fetched records:", records);
    const imageRanking = records.length > 0 ? records[0].fields["Image Ranking"] : null;

    console.log(`Image Ranking for email ${email}: ${imageRanking}`);
    return imageRanking;
  } catch (error) {
    console.error("Error fetching Image Ranking data:", error.response?.data || error.message);
    throw error;
  }
};


export const fetchAgentCoreMarketByEmail = async (email) => {
  try {
    console.log(`Fetching Agent Core Market Position for email: ${email}`);

    // Airtable formula to match the email
    const formula = `{Image Email}="${email}"`;
    const encodedFormula = encodeURIComponent(formula);

    // Table name from your screenshot: "Agent Core Market Position"
    const endpoint = `/Agent%20Core%20Market%20Position?filterByFormula=${encodedFormula}`;

    let records = [];
    let offset;

    // Handle pagination
    do {
      const response = await airtable.get(`${endpoint}&offset=${offset || ""}`);
      records = records.concat(response.data.records);
      offset = response.data.offset;
    } while (offset);

    console.log("Fetched records:", records);

    if (records.length > 0) {
      const data = records[0].fields;
      console.log(`Core Market data for ${email}:`, data);
      return data;
    }

    console.warn(`No Core Market record found for email: ${email}`);
    return null;
  } catch (error) {
    console.error(
      "Error fetching Agent Core Market Position:",
      error.response?.data || error.message
    );
    throw error;
  }
};
